import { createStore } from "vuex";
import { profile } from "./profile.store";
import { settings } from "./settings.store";

export const store = createStore({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        profile,
        settings,
    },
});
